const appInfo = {
    title: 'My Little Fairies',
    logo: 'logo.png',
    logo2: 'mlf.png',
    bgLogin: './background/bg6.jpg',
    // baseColor: '#E48866',
    menuId: {
        usage: 25,
        quotation: 48,
        salesOrder: 35,
        workOrder: 36,
        transferStok: 50,
        reclass: 51,
        bhp: 61,
        do: 62,
        invoice: 63,
        permintaan17: 88,
        accarr: 94,
        accapp: 95
    }
};
export default appInfo;